<img src="../../../../assets/images/TS-Loader.gif" class="QMS-logo" alt="MDR Logo">

  